<template>
  <q-input rounded outlined dense class="col-grow" style="flex-shrink: 1">
    <template v-slot:append>
      <slot name="append" />
    </template>
  </q-input>
</template>

<script setup></script>
